<template>
  <div
    :class="[
      'VisionSlidoTabs',
      'VisionSlidoTabs--direction-' + props.direction,
      {
        'VisionSlidoTabs--error': props.error,
      }
    ]"
  >
    <VisionSlidoTabsWrapper>
      <template
        v-for="(slotname, index) in orderedSlots"
        :key="index"
      >
        <slot :name="slotname" />
      </template>
    </VisionSlidoTabsWrapper>
  </div>
</template>

<script setup lang="ts">
import { useSlots, computed } from 'vue';
import VisionSlidoTabsWrapper from './VisionSlidoTabsWrapper.vue'

interface SlidoTabsProps {
  direction?: 'row' | 'column' | 'grid'
  selectedIndex?: null | 0
  error?: boolean
}

const props = withDefaults(defineProps<SlidoTabsProps>(), {
  direction: 'row',
  selectedIndex: null,
  error: false
})

const slots = useSlots();

function moveToTheEnd(arr, word){
  arr.map((elem, index) => {
    if(elem.toLowerCase() === word.toLowerCase()){
      arr.splice(index, 1);
      arr.push(elem);
    }
  })

  return arr;
}

const orderedSlots = computed(() => {
  const newSlots = Object.keys(slots)

  return moveToTheEnd(newSlots, 'after')
})
</script>

<style lang="postcss" scoped>
.VisionSlidoTabs {
  background-color: var(--vision-slido-bg-colour, theme('colors.grey-lighter'));
  border: 1px solid var(--vision-slido-border-colour, var(--vision-slido-bg-colour, theme('colors.grey-lighter')));
  flex-direction: var(--vision-slido-direction, row);

  @apply flex relative w-full rounded-lg;
}

.VisionSlidoTabs__slido {
  @apply absolute hidden;
}

.VisionSlidoTabs__tab {
  @apply flex-grow w-full;
}

.VisionSlidoTabs__content-wrapper {
  @apply h-full;
}

/**
    Modifiers

    --direction-{row,column, grid}
    --error
    --theme
*/
.VisionSlidoTabs--direction-column {
  flex-direction: var(--vision-slido-direction, column);
}

.VisionSlidoTabs--direction-grid {
  @apply grid;
  grid-template-columns: var(--vision-slido-grid-columns, repeat(2, 1fr));
}

.VisionSlidoTabs--error {
  @apply border-red;
}
</style>
